<template>
    <div class="background-color-white border-rounded">
        <slot/>
    </div>
</template>

<script>
    export default { name: "Panel_White" }
</script>
